import 'core-js/fn/array/from'

import whatInput from 'what-input'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark-reasonable.css'

import NavDropdown from './modules/NavDropdown'
import StickyHeader from './modules/StickyHeader'
import MV from './modules/MV'
import AnchorLink from './modules/AnchorLink'
import InView from './modules/InView'
import Accordion from './modules/Accordion'

document.addEventListener('DOMContentLoaded', event => {
  const navDropdown = new NavDropdown()
  navDropdown.init()

  const stickyHeader = new StickyHeader()
  stickyHeader.init()

  const anchorLink = new AnchorLink()
  anchorLink.init()

  // スムーズスクロール中はヘッダーのfixed処理を停止
  anchorLink.on('scrollStart', () => {
    stickyHeader.deactivate()
    stickyHeader.hiddenNav()
    navDropdown.closeMenu()
  })
  anchorLink.on('scrollStop', () => {
    setTimeout(() => {
      stickyHeader.activate()
    }, 300);
  })

  const inView = new InView()
  inView.init()

  if (document.querySelector('#mvSlide') && document.querySelector('#mvCopy')) {
    const mv = new MV()
    mv.init()
  }

  const accordionEl = document.querySelectorAll('.js-accordion')
    ;[...accordionEl].forEach(el => {
      new Accordion(el)
    })

  const highlightEl = document.querySelectorAll('.p-columnDetail__editor pre code')
    ;[...highlightEl].forEach(el => {
      console.log(el)
      hljs.highlightBlock(el)
    })
})



// WEBPACK FOOTER //
// ./src/script/script.js